module.exports = __webpack_public_path__ + "static/DWI20_Reg_1700x1200_HessischeBergstrasse-67a5cba9bbde1e90c19408d2ce7eb24f.jpeg";